export function resolveMediaUrl(url) {
  const value = String(url || '').trim()
  if (!value) return ''
  if (/^https?:\/\//i.test(value) || value.startsWith('data:') || value.startsWith('blob:')) {
    return value
  }
  const base = (process.env.VUE_APP_APIENDPOINT || '').replace(/\/+$/, '')
  if (!base) return value
  return `${base}/${value.replace(/^\/+/, '')}`
}
